import { parseLocalDate } from "./dateUtils";

/**
 * Calculates the effective status of a property based on closed date and contract expiration.
 * This ensures consistent status logic across the entire application.
 * 
 * Key rule: Properties expiring TODAY are considered expired (uses <= comparison).
 */
export function getEffectiveStatus(
  status: string,
  closedDate: string | null,
  contractExpirationDate: string | null
): "active" | "pending" | "closed" | "sold" | "expired" | "draft" {
  // Draft properties stay as draft — no expiration or sold logic applied
  if (status === 'draft') {
    return "draft";
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // If property has a closed date, it's sold
  if (closedDate) {
    return "sold";
  }
  
  // If contract expiration date has passed or is TODAY, it's expired
  if (contractExpirationDate) {
    const expirationDate = parseLocalDate(contractExpirationDate);
    if (expirationDate) {
      expirationDate.setHours(0, 0, 0, 0);
      if (expirationDate <= today) {  // Note: <= instead of < to include today
        return "expired";
      }
    }
  }
  
  // Otherwise use the database status
  return status as "active" | "pending" | "closed";
}

